import React, { useState, forwardRef, useImperativeHandle } from 'react';


const Compliance = forwardRef((props, ref) => {
     // Add validation support  
     const [validationErrors, setValidationErrors] = useState({});

     useImperativeHandle(ref, () => ({
          validateForm: () => {
               return true; // For now, always return true
          },
          clearValidation: () => {
               setValidationErrors({});
          }
     }));

     const [localFormData, localSetFormData] = useState({
          aadhar_number: '',
          pan_number: '',
          tds_status: '',
     });
     const formData = props.formData !== undefined ? props.formData : localFormData;
     const setFormData = props.setFormData !== undefined ? props.setFormData : localSetFormData;

     return (
          <div className="custom_form_wrapper">
               <div className="form-grid">
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="aadhar_number"
                              id="aadhar_number"
                              placeholder="Aadhar Number"
                              value={formData.aadhar_number}
                              onChange={e => setFormData({ ...formData, aadhar_number: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="aadhar_number">Aadhar Number</label>
                    </div>
                    <div className="form-floating">
                         <input
                              type="text"
                              className="form-control form-control-sm"
                              name="pan_number"
                              id="pan_number"
                              placeholder="PAN Number"
                              value={formData.pan_number}
                              onChange={e => setFormData({ ...formData, pan_number: e.target.value })}
                              autoComplete="off"
                         />
                         <label htmlFor="pan_number">PAN Number</label>
                    </div>
                    <div className="form-floating">
                         <select
                              className="form-select "
                              name="tds_status"
                              id="tds_status"
                              value={formData.tds_status ?? ''}
                              onChange={e => setFormData({ ...formData, tds_status: e.target.value })}
                         >
                              <option value="" disabled hidden>TDS Status</option>
                              <option value="Applicable">Applicable</option>
                              <option value="Not Applicable">Not Applicable</option>
                         </select>
                         <label htmlFor="tds_status" style={{ opacity: (formData.tds_status ?? '') ? 1 : 0 }}>TDS Status</label>
                    </div>
               </div>
          </div>
     );
});

export default Compliance;